import api from './api';
import type { ContractDetails, StudentContract } from '../types/studentPortal';

/** The exact server-side price for a set of answers. Nothing is stored. */
export interface PublicQuotePreview {
  currency: string;
  regular_total: string;
  payable_total: string;
  discount_amount: string;
  payment_mode: 'installments' | 'full_advance' | string;
  package_title?: string | null;
  payment_schedule: { order?: number | null; title?: string | null; amount: string }[];
}

export interface PublicContractRequest extends ContractDetails {
  country_id: number;
  answers: Record<string, string>;
  full_name: string;
  email: string;
}

export interface PublicContractCreated {
  /** Secret needed to record this contract's download. Returned only once. */
  access_token: string;
  /** Same shape as the portal's contract, so ContractDocument renders it. */
  contract: StudentContract;
}

class PublicContractService {
  async previewQuote(countryId: number, answers: Record<string, string>): Promise<PublicQuotePreview> {
    const { data } = await api.post<PublicQuotePreview>('/public-contracts/quote', { country_id: countryId, answers });
    return data;
  }

  async create(payload: PublicContractRequest): Promise<PublicContractCreated> {
    const { data } = await api.post<PublicContractCreated>('/public-contracts', payload);
    return data;
  }

  async recordDownload(contractNumber: string, accessToken: string): Promise<void> {
    await api.post(`/public-contracts/${encodeURIComponent(contractNumber)}/download`, { access_token: accessToken });
  }
}

export default new PublicContractService();
